import * as React from 'react';
import { convertArrayToObject } from '../utils';
import { omit, pickBy } from 'lodash';

const SatelliteImagesContext = React.createContext()


export function satelliteImageReducer(state, action) {
  switch (action.type) {
      case 'ADD_IMAGES': {
          const newImagesKeys = Object.keys(action.payload).filter((key) => (key in state))
          return {...state, ...omit(action.payload, newImagesKeys)}
      }
      case 'DELETE_IMAGES': {
          return pickBy(state, (val, key) => state[key].parcel.id !== action.payload.id )
      }
      case 'VIEW_ON_MAIN_MAP': {
          const newStateArray = Object.keys(state).map((key) => { 
            if (action.payload.parcel.id === state[key].parcel.id){
              if (action.payload.parcelUrl === state[key].parcelUrl){
                return { ...state[key], visibleOnMainMap: true } 
              } else if (action.payload.layer.name === state[key].layer.name)
                return { ...state[key], visibleOnMainMap: false } 
              else
                return { ...state[key] }
            }

            return { ...state[key] }
          })
          
          return convertArrayToObject(newStateArray, 'parcelUrl')
      }
      default:
          return state
  }
}

function SatelliteImagesProvider({ children }) {

  const [satelliteImages, dispatchSatelliteImages] = React.useReducer(satelliteImageReducer, []);

  const value = { satelliteImages, dispatchSatelliteImages }

  return <SatelliteImagesContext.Provider value={value}>{children}</SatelliteImagesContext.Provider>
}

function useSatelliteImages() {
  const context = React.useContext(SatelliteImagesContext)
  if (context === undefined) {
    throw new Error(`useSatelliteImages must be used within a SatelliteImagesProvider`)
  }
  return context
}

export { SatelliteImagesProvider, useSatelliteImages }